import { z } from 'zod'

import { dbEntitySchema, listQueryZodFields } from './system'
import { CustomerTagType } from '../constants/customerTag'

const baseTagProps = {
  id: z.string(),
  // _id: z.string(),
  value: z.string(),
  backgroundColor: z.string().nullish(),
  textColor: z.string().nullish(),
  icon: z.string().optional().nullable(),
  type: z.nativeEnum(CustomerTagType).default(CustomerTagType.CUSTOM),
}

export const customerTagBaseSchema = z.object(baseTagProps)

/** Embedded customer tag on admission groups (API create/update); `id` required, other fields optional denorms. */
export const admissionGroupCustomerTagEmbeddedSchema = customerTagBaseSchema
  .partial()
  .extend({ id: z.string() })

export const customerTagSchema = dbEntitySchema.extend({
  ...baseTagProps,
  organization: z.string(),
})

export const customerTagListQuerySchema = z.object({
  ...listQueryZodFields,
  organizationId: z.string(),
  search: z.string().optional().nullable(),
  type: z
    .nativeEnum(CustomerTagType)
    .or(z.array(z.nativeEnum(CustomerTagType)))
    .optional()
    .nullable(),
})

export const customerTagCreateSchema = customerTagSchema
  .omit({
    _id: true,
    id: true,
    deleted: true,
    created: true,
    modified: true,
    organization: true,
    type: true,
  })
  .extend({
    organizationId: z.string(),
  })

export const customerTagUpdateByIdSchema = customerTagSchema.partial().omit({
  _id: true,
  id: true,
  deleted: true,
  created: true,
  modified: true,
  organization: true,
  type: true,
})

export const customerTagListResponseSchema = z.object({
  data: z.array(customerTagSchema),
})
